{
  "views": {
    "today": "Today",
    "day": "Day",
    "threeDay": "3 Days",
    "week": "Week",
    "month": "Month",
    "prevPeriodAriaLabel": "Previous period",
    "nextPeriodAriaLabel": "Next period",
    "filterPlaceholder": "filter event",
    "filterAriaLabel": "Filter event"
  },
  "timeAreas": {
    "button": "Time Areas",
    "edit": "Edit",
    "backAriaLabel": "Back to area list",
    "nameAriaLabel": "Time area name",
    "startTimeAriaLabel": "Start time, {{day}}",
    "endTimeAriaLabel": "End time, {{day}}",
    "notAvailable": "Not available",
    "disableDay": "Disable day",
    "enableDay": "Enable day",
    "disableDayAriaLabel": "Disable {{day}}",
    "enableDayAriaLabel": "Enable {{day}}",
    "days": {
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun"
    },
    "defaults": {
      "work": "Work",
      "appointments": "Appointments",
      "exercise": "Exercise"
    }
  },
  "recurrenceModal": {
    "title": "Recurring Event",
    "question": "Do you want to apply the changes only to this event or to the entire series?",
    "onlyThisEvent": "Only this event",
    "allEvents": "All events",
    "cancel": "Cancel"
  },
  "toast": {
    "eventUpdated": "Event updated.",
    "errorSavingTime": "Error saving the time",
    "networkErrorSaving": "Network error while saving",
    "areaUpdated": "Area updated.",
    "errorSavingArea": "Error saving the area",
    "networkError": "Network error",
    "eventMoved": "Event moved.",
    "errorMoving": "Error moving the event",
    "networkErrorMoving": "Network error while moving"
  },
  "sidePanel": {
    "tabs": {
      "settings": "Settings",
      "activities": "Activity"
    },
    "filterByPerson": "Filter by person",
    "searchPersonPlaceholder": "Search person...",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "noUsersFound": "No users found",
    "noUserSelected": "No user selected",
    "myCalendars": "My Calendars",
    "doubleClickToEdit": "Double click to edit",
    "openPublicCalendly": "Open public Calendly",
    "calendlyWork": "Calendly (work)",
    "copyLink": "Copy link",
    "noRecentActivities": "No recent activities",
    "newCalendarDefaultName": "New Calendar"
  },
  "calendarEditor": {
    "title": "Edit Calendar",
    "nameLabel": "Calendar Name",
    "timezoneLabel": "Time Zone",
    "ownerLabel": "Owner",
    "ownerTag": "(Owner)",
    "defaultOwnerName": "You",
    "sharedWithLabel": "Shared with",
    "invitePlaceholder": "Invite users...",
    "noUsersFound": "No users found",
    "notSharedYet": "Not shared with anyone yet.",
    "permissionsNote": "Users with access can view and edit events on this calendar.",
    "protectWithPassword": "Protect with password",
    "share": "Share",
    "dataAndRecordings": "Data and recordings",
    "confirmDelete": "Delete permanently?",
    "cancel": "Cancel",
    "yesDelete": "Yes, delete",
    "deleteCalendar": "Delete calendar"
  },
  "eventCard": {
    "untitled": "Untitled Event"
  },
  "eventModal": {
    "editTitle": "Edit event",
    "createTitle": "Create Event",
    "titlePlaceholder": "Add title",
    "start": "Start",
    "end": "End",
    "loadingCalendars": "Loading calendars...",
    "organizerCalendar": "Organizer's Calendar",
    "addGuestsPlaceholder": "Add guests",
    "organizerTag": "(Organizer)",
    "addGoogleMeet": "Add Google Meet video conferencing",
    "addLocationPlaceholder": "Add location",
    "addDescriptionPlaceholder": "Add description",
    "visibility": {
      "default": "Default Visibility",
      "private": "Private",
      "public": "Public"
    },
    "recurringButton": "Recurring event",
    "recurrence": {
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "yearly": "Yearly",
      "weekDayLetters": ["S", "M", "T", "W", "T", "F", "S"]
    },
    "moreOptions": "More options",
    "deleteEventTitle": "Delete event",
    "declineInvitationTitle": "Decline invitation",
    "declineButton": "Decline",
    "confirmDeclineQuestion": "Are you sure you don't want to accept?",
    "yes": "Yes",
    "cancel": "Cancel",
    "save": "Save"
  }
}
